export const COUNTERPARTY_RATINGS = ['A+', 'A', 'B', 'C', 'S/D'] as const;

export type CounterpartyRatingProps = typeof COUNTERPARTY_RATINGS[number];
export type CounterpartyRatingFilterProps = 'A_PLUS' | 'A' | 'B' | 'C' | 'WITHOUT_RATING';

export const COUNTERPARTY_RATING_BG_BY_LABEL: Record<CounterpartyRatingProps, string> = {
  'A+': '#38A169',
  A: '#D69E2E',
  B: '#DD6B20',
  C: '#E53E3E',
  'S/D': '#718096',
};

const toCounterpartyRatingLabel = (value?: string | null): CounterpartyRatingProps | undefined => {
  const normalized = String(value || '').toUpperCase();
  const normalizedWithPlus = normalized.replace(/\s+/g, '+').trim();
  const normalizedWithUnderscore = normalized.trim().replace(/\s+/g, '_');

  if (normalizedWithPlus === 'A+' || normalizedWithUnderscore === 'A_PLUS') {
    return 'A+';
  }

  if (normalizedWithPlus === 'A') {
    return 'A';
  }

  if (normalizedWithPlus === 'B') {
    return 'B';
  }

  if (normalizedWithPlus === 'C') {
    return 'C';
  }

  if (normalizedWithPlus === 'S/D' || normalizedWithPlus === 'SD' || normalizedWithUnderscore === 'WITHOUT_RATING') {
    return 'S/D';
  }

  return undefined;
};

export const toCounterpartyRatingFilterValue = (rating: CounterpartyRatingProps): CounterpartyRatingFilterProps => {
  if (rating === 'A+') {
    return 'A_PLUS';
  }

  if (rating === 'S/D') {
    return 'WITHOUT_RATING';
  }

  return rating;
};

export const fromCounterpartyRatingFilterValue = (value?: string | null): CounterpartyRatingProps | undefined =>
  toCounterpartyRatingLabel(value);

export const normalizeCounterpartyRating = (value?: string): CounterpartyRatingProps => toCounterpartyRatingLabel(value) || 'S/D';
